import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Calender, TextInputForm, DropDownUI } from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { ClickButton, Delete } from "../components/Buttons";
import API_DOMAIN from "../config/config";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
const DOMAIN = "https://viswacrackers.zentexus.in/api";

const alltax = [
  {
    value: "IGST@0%",
    label: "IGST@0%",
  },
  {
    value: "GST@0%",
    label: "GST@0%",
  },
  {
    value: "IGST@0.25%",
    label: "IGST@0.25%",
  },
  {
    value: "GST@0.25%",
    label: "GST@0.25%",
  },
  {
    value: "IGST@3%",
    label: "IGST@3%",
  },
  {
    value: "GST@3%",
    label: "GST@3%",
  },
  {
    value: "IGST@5%",
    label: "IGST@5%",
  },
  {
    value: "GST@5%",
    label: "GST@5%",
  },
  {
    value: "IGST@12%",
    label: "IGST@12%",
  },
  {
    value: "GST@12%",
    label: "GST@12%",
  },
  {
    value: "IGST@18%",
    label: "IGST@18%",
  },
  {
    value: "GST@18%",
    label: "GST@18%",
  },
  {
    value: "IGST@28%",
    label: "IGST@28%",
  },
  {
    value: "GST@28%",
    label: "GST@28%",
  },
];
const allovertax = [
  {
    value: "IGST@0%",
    label: "IGST@0%",
  },
  {
    value: "GST@0%",
    label: "GST@0%",
  },
  {
    value: "IGST@0.25%",
    label: "IGST@0.25%",
  },
  {
    value: "GST@0.25%",
    label: "GST@0.25%",
  },
  {
    value: "IGST@3%",
    label: "IGST@3%",
  },
  {
    value: "GST@3%",
    label: "GST@3%",
  },
  {
    value: "IGST@5%",
    label: "IGST@5%",
  },
  {
    value: "GST@5%",
    label: "GST@5%",
  },
  {
    value: "IGST@12%",
    label: "IGST@12%",
  },
  {
    value: "GST@12%",
    label: "GST@12%",
  },
  {
    value: "IGST@18%",
    label: "IGST@18%",
  },
  {
    value: "GST@18%",
    label: "GST@18%",
  },
  {
    value: "IGST@28%",
    label: "IGST@28%",
  },
  {
    value: "GST@28%",
    label: "GST@28%",
  },
];

const DropList = [
  {
    value: "DR",
    label: "DR",
  },
  {
    value: "CR",
    label: "CR",
  },
];

const WholeSaleBillEntry = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [roundoff, setRoundoff] = useState(false);
  const [roundoffAmount, setRoundoffAmount] = useState(0);
  const [originalTotal, setOriginalTotal] = useState(null);
  const navigate = useNavigate();
  const [tax_type, settax_type] = useState("");

  const initialState =
    type === "edit"
      ? {
        ...rowData,
        product: rowData.products
          ? rowData.products.map((prod) => ({
            MarksNo: prod.MarksNo,
            product_id: prod.product_id,
            remark: prod.remark,
            product_name: prod.product_name,
            qty: prod.qty,
            unit: prod.unit,
            price_unit: prod.price_unit,
            discount_percentage: prod.discount_percentage,
            discount_amt: prod.discount_amt,
            hsn_no: prod.hsn_no,
            tax_type: prod.tax_type,
            tax_percentage: prod.tax_percentage,
            tax_amt: prod.tax_amt,
            total_amt: prod.total_amt,
            unit_name: prod.unit_name,
          }))
          : [],
        round_off_checkbox: rowData.round_off_checkbox === 1,
      }
      : {
        party_id: "",
        partyname: "",
        partyaddress: "",
        placeofsupply: "",
        bill_no: "",
        bill_date: "",
        from: "",
        to: "",
        purchase_gst: "",
        receipt_number: "",
        transport_gst_no: "",
        purchasemobile_no: "",
        total: "",
        paid: "",
        balance_amount: "",
        final_total: "",
        discount_all: "",
        total_discountall: "",
        taxover_amt: "",
        taxover_percentage: "",
        roundoffAmount: "0.00",
        despatched_by: "",
        globalGST: "",
        product: [
          {
            MarksNo: "",
            product_id: "",
            product_name: "",
            qty: "",
            unit: "",
            price_unit: "",
            discount_percentage: "",
            discount_amt: "",
            hsn_no: "",
            tax_type: "",
            tax_percentage: "",
            tax_amt: "",
            total_amt: "",
          },
        ],
        round_off_checkbox: false,
      };

  const [formData, setFormData] = useState({
    ...initialState,
    bill_date: type === "edit" ? new Date(rowData.bill_date) : new Date(),
  });
  console.log(formData);
  useEffect(() => {
    setRoundoff(formData.round_off_checkbox || false);
  }, [formData.round_off_checkbox]);

  const formatDateString = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const setLabel = (date, type) => {
    if (date instanceof Date && !isNaN(date)) {
      setFormData((prev) => ({
        ...prev,
        [type]: formatDateString(date),
      }));
    } else {
      console.error("Invalid date format received");
    }
  };

  const handleAddRow = () => {
    const newProduct = {
      MarksNo: "",
      product_id: "",
      product_name: "",
      qty: "",
      unit: "",
      price_unit: "",
      discount_percentage: "",
      discount_amt: "",
      hsn_no: "",
      tax_type: formData.globalGST ? formData.globalGST.split("@")[0] : "",
      tax_percentage: formData.globalGST || "",
      tax_amt: "0.00",
      total_amt: "0.00",
    };

    setFormData((prevState) => ({
      ...prevState,
      product: [...prevState.product, newProduct],
    }));
  };

  useEffect(() => {
    calculateTotal(formData.product);
    if (formData.globalGST) {
      handleGlobalGST({ globalGST: formData.globalGST });
    }
  }, [formData.product]);

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };

  const handleTotalChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      total: e.target.value,
    }));
  };

  const handlePaidChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: e.target.value,
    }));
  };

  const handleRoundoffChange = (e) => {
    const isChecked = e.target.checked;
    setRoundoff(isChecked);
    setFormData((prevData) => ({
      ...prevData,
      round_off_checkbox: isChecked,
    }));

    let finalTotal = parseFloat(formData.final_total) || 0;
    let roundedTotal = Math.round(finalTotal);
    let roundDiff = (roundedTotal - finalTotal).toFixed(2);

    if (isChecked) {
      if (originalTotal === null) {
        setOriginalTotal(finalTotal);
      }

      setFormData((prevData) => ({
        ...prevData,
        final_total: roundedTotal.toFixed(2),
        roundoffAmount: roundDiff,
      }));
    } else {
      const revertTotal =
        originalTotal !== null
          ? originalTotal.toFixed(2)
          : (
            parseFloat(formData.total) + parseFloat(formData.taxover_amt || 0)
          ).toFixed(2);

      setFormData((prevData) => ({
        ...prevData,
        final_total: revertTotal,
        roundoffAmount: "0.00",
      }));

      setOriginalTotal(null);
    }
  };

  useEffect(() => {
    const updateBalance = () => {
      const finalTotal = parseFloat(formData.final_total) || 0;
      const paid = parseFloat(formData.paid) || 0;
      const balanceAmount = finalTotal - paid;

      setFormData((prevData) => ({
        ...prevData,
        balance_amount: balanceAmount.toFixed(2),
      }));
    };

    updateBalance();
  }, [formData.final_total, formData.paid]);

  const handleGlobalGST = (updatedFormData) => {
    if (!updatedFormData.globalGST) {
      console.error("globalGST is undefined or empty!");
      return;
    }

    const selectedTax = alltax.find(
      (tax) => tax.value === updatedFormData.globalGST
    );

    if (!selectedTax) {
      console.error("Invalid GST value selected:", updatedFormData.globalGST);
      return;
    }

    const taxValueMatch = updatedFormData.globalGST.match(/\d+\.*\d*/);
    if (!taxValueMatch) {
      console.error("Invalid GST format:", updatedFormData.globalGST);
      return;
    }

    const taxValue = parseFloat(taxValueMatch[0]);
    const taxType = selectedTax.value.split("@")[0];

    const totalAmount = parseFloat(formData.total) || 0;
    const gstAmount = (totalAmount * taxValue) / 100;
    let finalTotal = totalAmount + gstAmount;

    if (roundoff) {
      const roundedTotal = Math.round(finalTotal);
      const roundDiff = (roundedTotal - finalTotal).toFixed(2);
      setFormData((prevData) => ({
        ...prevData,
        globalGST: updatedFormData.globalGST,
        taxover_amt: gstAmount.toFixed(2),
        final_total: roundedTotal.toFixed(2),
        roundoffAmount: roundDiff,
        product: prevData.product.map((row) => ({
          ...row,
          tax_type: taxType,
          tax_percentage: updatedFormData.globalGST,
          tax_amt: "0.00",
        })),
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        globalGST: updatedFormData.globalGST,
        taxover_amt: gstAmount.toFixed(2),
        final_total: finalTotal.toFixed(2),
        roundoffAmount: "0.00",
        product: prevData.product.map((row) => ({
          ...row,
          tax_type: taxType,
          tax_percentage: updatedFormData.globalGST,
          tax_amt: "0.00",
        })),
      }));
    }
  };

  const calculateTotal = (product = []) => {
    const totalAmount = product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );

    setFormData((prevData) => {
      let taxAmount = parseFloat(prevData.taxover_amt) || 0;
      let finalTotal = totalAmount + taxAmount;

      if (roundoff) {
        const roundedTotal = Math.round(finalTotal);
        const roundDiff = (roundedTotal - finalTotal).toFixed(2);
        return {
          ...prevData,
          total: totalAmount.toFixed(2),
          final_total: roundedTotal.toFixed(2),
          roundoffAmount: roundDiff,
        };
      }

      return {
        ...prevData,
        total: totalAmount.toFixed(2),
        final_total: finalTotal.toFixed(2),
        roundoffAmount: "0.00",
      };
    });
  };

  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.product[formData.product.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit &&
        lastRow.price_unit &&
        lastRow.total_amt
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    let updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    if (
      rowIndex !== undefined &&
      ["qty", "price_unit", "discount_percentage", "discount_amt"].includes(
        fieldName
      )
    ) {
      updatedFormData.product = updatedFormData.product.map((row, index) => {
        if (index === rowIndex) {
          const qty = parseFloat(row.qty) || 0;
          const price = parseFloat(row.price_unit) || 0;
          const discountPercentage = parseFloat(row.discount_percentage) || 0;
          const discountInputAmount = parseFloat(row.discount_amt) || 0;

          let subtotal = qty * price;
          let crtdiscountFiled = 0.0;

          if (fieldName === "price_unit" || fieldName === "qty") {
            crtdiscountFiled = isNaN(discountPercentage)
              ? 0
              : (subtotal * discountPercentage) / 100;
            row.discount_amt = crtdiscountFiled.toFixed(2);
          } else if (fieldName === "discount_percentage") {
            crtdiscountFiled = isNaN(discountPercentage)
              ? 0
              : (subtotal * discountPercentage) / 100;
            row.discount_amt = crtdiscountFiled.toFixed(2);
          } else if (fieldName === "discount_amt") {
            crtdiscountFiled = isNaN(discountInputAmount)
              ? 0
              : discountInputAmount;
            const cal = subtotal > 0 ? (crtdiscountFiled / subtotal) * 100 : 0;
            row.discount_percentage = isNaN(cal)
              ? 0
              : parseFloat(cal).toFixed(2);
          }

          let finalAmount = subtotal - crtdiscountFiled;
          row.tax_amt = "0.00";
          row.total_amt = finalAmount.toFixed(2);
        }
        return row;
      });

      const totalAmount = updatedFormData.product.reduce(
        (acc, row) => acc + parseFloat(row.total_amt || 0),
        0
      );
      updatedFormData.total = totalAmount.toFixed(2);

      if (formData.globalGST) {
        const taxValue =
          parseFloat(formData.globalGST.match(/\d+\.*\d*/)[0]) || 0;
        const gstAmount = (totalAmount * taxValue) / 100;
        updatedFormData.taxover_amt = gstAmount.toFixed(2);
        updatedFormData.final_total = (totalAmount + gstAmount).toFixed(2);
      }
    }

    setFormData(updatedFormData);
  };

  function calculateTax(product, tax_percentage, index, taxType) {
    if (!tax_percentage) {
      console.error("Tax percentage is undefined for product:", product);
      return;
    }

    let updatedFormData = { ...formData };
    let sgst = 0,
      cgst = 0,
      igst = 0;

    let producttotal = parseFloat(product.total_amt) || 0;
    const taxValue = tax_percentage.match(/\d+\.*\d*/);
    if (!taxValue) {
      console.error("Invalid tax percentage format:", tax_percentage);
      return;
    }

    let taxAmt = (producttotal * parseFloat(taxValue[0])) / 100;

    if (taxType === "GST") {
      const taxAmount = taxAmt / 2;
      sgst = taxAmount;
      cgst = taxAmount;
    } else if (taxType === "IGST") {
      igst = taxAmt;
    }

    updatedFormData.product[index].SGST = sgst.toFixed(2);
    updatedFormData.product[index].CGST = cgst.toFixed(2);
    updatedFormData.product[index].IGST = igst.toFixed(2);
    updatedFormData.product[index].tax_type = taxType;
    updatedFormData.product[index].tax_amt = "0.00";

    setFormData(updatedFormData);
  }

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);
  const [partySalesData, setPartySalesData] = useState([]);

  const fetchPartySalesData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      setLoading(false);
      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchPartySalesData();
  }, []);
  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const companyId = localStorage.getItem("companyId");
        const response = await fetch(`${DOMAIN}/products.php?id=${companyId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setLoading(responseData);

        if (responseData.status === 200) {
          setProductData(responseData.data);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading();
        console.error("Error fetching data:", error.message);
      }
    };

    fetchProductData();
  }, []);
  const [UnitData, setUnitData] = useState([]);
  const fetchUnitData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      setLoading(false);
      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchUnitData();
  }, []);
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    try {
      const sanitizedFormData = {
        ...formData,
        round_off_checkbox: roundoff ? 1 : 0,
        roundoffAmount: isNaN(parseFloat(formData.roundoffAmount))
          ? "0.00"
          : parseFloat(formData.roundoffAmount).toFixed(2),
        taxover_amt: isNaN(parseFloat(formData.taxover_amt))
          ? "0.00"
          : parseFloat(formData.taxover_amt).toFixed(2),
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || 0,
          tax_percentage: product.tax_percentage || 0,
          hsn_no: product.hsn_no || "",
          remark: product.remark || "",
        })),
      };

      const response = await fetch(`${API_DOMAIN}/wholesale_invoice.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sanitizedFormData),
      });

      const responseData = await response.json();
      console.log("handleSubmit responseData", responseData);

      if (responseData.status === 200) {
        setFormData(initialState);
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/sales/wholesale");
        }, 2000);
      } else {
        toast.error(responseData.msg || "Error submitting invoice");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      const sanitizedFormData = {
        ...formData,
        update_wholesale_id: rowData.invoice_id,
        round_off_checkbox: roundoff ? 1 : 0,
        roundoffAmount: isNaN(parseFloat(formData.roundoffAmount))
          ? "0.00"
          : parseFloat(formData.roundoffAmount).toFixed(2),
        taxover_amt: isNaN(parseFloat(formData.taxover_amt))
          ? "0.00"
          : parseFloat(formData.taxover_amt).toFixed(2),
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || 0,
          tax_percentage: product.tax_percentage || 0,
          hsn_no: product.hsn_no || "",
          remark: product.remark || "",
        })),
      };
      const response = await fetch(`${API_DOMAIN}/wholesale_invoice.php`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sanitizedFormData),
      });

      const responseData = await response.json();
      console.log("handleUpdateSubmit responseData", responseData);
      if (responseData.status === 200) {
        toast.success("Wholesale Bill updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/sales/wholesale");
        }, 2000);
      } else {
        console.error(
          responseData.msg || "Unknown error occurred during update"
        );
      }
    } catch (error) {
      console.error("Error updating product:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    });
  });

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <div>
        <div className="main">
          <Container fluid>
            <Row>
              <Col lg="12">
                <PageHead
                  pagehead={<>Wholesale Bill</>}
                  onClick={() => navigate(-1)}
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="main my-3">
          <div>
            <Container fluid>
              <Row>
                <Col lg="12">
                  <Table>
                    <tr>
                      <td>
                        <div className="d-flex">
                          <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"Party Name"}
                              labelname={"Party Name"}
                              required={"*"}
                              name="partyname"
                              value={formData.partyname}
                              onChange={(e) => handleChange(e, "partyname")}
                            />
                          </div>

                          <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"Party Address"}
                              labelname={"Party Address"}
                              required={"*"}
                              name="partyaddress"
                              value={formData.partyaddress}
                              onChange={(e) => handleChange(e, "partyaddress")}
                            />
                          </div>

                          <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"Place Of Supply"}
                              labelname={"Place Of Supply"}
                              required={"*"}
                              name="placeofsupply"
                              value={formData.placeofsupply}
                              onChange={(e) => handleChange(e, "placeofsupply")}
                            />
                          </div>
                          <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"Party GST"}
                              labelname={"Party GST"}
                              required={"*"}
                              name="purchase_gst"
                              value={formData.purchase_gst}
                              onChange={(e) => handleChange(e, "purchase_gst")}
                            />
                          </div>

                          <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"PartyMobileNumber"}
                              labelname={"PartyMobileNumber"}
                              required={"*"}
                              name="purchasemobile_no"
                              value={formData.purchasemobile_no}
                              onChange={(e) =>
                                handleChange(e, "purchasemobile_no")
                              }
                            />
                          </div>
                          <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"State"}
                              labelname={"State"}
                              required={"*"}
                              name="state"
                              value={formData.state}
                              onChange={(e) => handleChange(e, "state")}
                            />
                          </div>
                        </div>
                      </td>
                      <td className="mx-auto float-end">
                        <div className="">
                          <span>
                            <TextInputForm
                              placeholder={"Invoice Number"}
                              labelname={"Invoice Number"}
                              required={"*"}
                              name="bill_no"
                              value={formData.bill_no}
                              onChange={(e) => handleChange(e, "bill_no")}
                              disabled={type === "edit"}
                            />
                          </span>
                        </div>
                        <div>
                          <div className="text-left ml-1 "></div>
                          <Calender
                            required={"*"}
                            setLabel={(date) => setLabel(date, "bill_date")}
                            initialDate={formData.bill_date}
                            calenderlabel="BillDate"
                          />
                        </div>
                      </td>
                    </tr>
                  </Table>
                </Col>
                <Col lg="12" className="py-3">
                  <div>
                    No Of Products :{" "}
                    <span>{formData?.product?.length || 0}</span>
                  </div>
                </Col>
                <Col lg="12" md="6" xs="12">
                  <div className="py-2 category-table bill">
                    <Table>
                      <thead className="">
                        <tr>
                          {/* <th rowSpan={2} className="wrdbrk w-4">
                            Marks & No.
                          </th> */}
                          <th rowSpan={2} className="wrdbrk w-10">
                            Product Name
                          </th>
                          <th rowSpan={2} className="wrdbrk w-5">
                            Qty
                          </th>
                          <th rowSpan={2} className="wrdbrk w-10">
                            Per
                          </th>
                          <th rowSpan={2} className="wrdbrk w-7">
                            Price / Unit
                          </th>
                          <th rowSpan={2} className="wrdbrk w-10">
                            Amount
                          </th>
                            <th rowSpan={2} className="wrdbrk w-7"></th>
                          <th rowSpan={2} className="wrdbrk w-10"></th>
                        </tr>
                        
                      </thead>
                      <tbody>
                        {formData.product &&
                          formData.product.map((row, index) => (
                            <tr key={index}>
                              {/* <td>
                                <TextInputForm
                                  placeholder={"No"}
                                  name="Marks & No"
                                  value={row.MarksNo}
                                  onChange={(e) =>
                                    handleChange(e, "MarksNo", index)
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                ></TextInputForm>
                              </td> */}
                              <td>
                                <div>
                                  <DropDownUI
                                    optionlist={productData.map((user) => ({
                                      value: user.product_id,
                                      label: `${user.product_code} - ${user.product_name}`,
                                    }))}
                                    placeholder="ProductName"
                                    filterOption={(option, input) => {
                                      const searchText = input.toLowerCase();
                                      const product = productData.find(
                                        (p) => p.product_id === option.value
                                      );
                                      return (
                                        product.product_code
                                          .toLowerCase()
                                          .includes(searchText) ||
                                        product.product_name
                                          .toLowerCase()
                                          .includes(searchText)
                                      );
                                    }}
                                    name="product_id"
                                    value={row.product_id}
                                    onChange={(updatedFormData) => {
                                      const selectedProduct = productData.find(
                                        (user) =>
                                          user.product_id ===
                                          updatedFormData.product_id
                                      );

                                      setFormData({
                                        ...formData,
                                        product: formData.product.map((r, i) =>
                                          i === index
                                            ? {
                                              ...r,
                                              product_id:
                                                updatedFormData.product_id,
                                              hsn_no: selectedProduct
                                                ? selectedProduct.hsn_no
                                                : "",
                                              product_name: selectedProduct
                                                ? selectedProduct.product_name
                                                : "",
                                              unit: selectedProduct
                                                ? selectedProduct.unit_id
                                                : "",
                                            }
                                            : r
                                        ),
                                      });
                                    }}
                                    onKeyDown={(e) => handleKeyPress(e, index)}
                                    autoFocus={
                                      index === formData.product.length - 1
                                    }
                                  />
                                </div>
                                <div>
                                  <TextInputForm
                                    placeholder={"Remarks"}
                                    name="remark"
                                    value={row.remark}
                                    onChange={(e) =>
                                      handleChange(e, "remark", index)
                                    }
                                    onKeyDown={(e) => handleKeyPress(e, index)}
                                  />
                                </div>
                              </td>
                              <td>
                                <TextInputForm
                                  placeholder={"qty"}
                                  name="qty"
                                  value={row.qty}
                                  onChange={(e) =>
                                    handleChange(e, "qty", index)
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                ></TextInputForm>
                              </td>
                              <td>
                                <DropDownUI
                                  optionlist={UnitData.map((user) => ({
                                    value: user.unit_id,
                                    label: user.unit_name,
                                  }))}
                                  placeholder="Unit"
                                  name="unit"
                                  value={row.unit}
                                  onChange={(updatedFormData) =>
                                    setFormData({
                                      ...formData,
                                      product: formData.product.map((r, i) =>
                                        i === index
                                          ? { ...r, unit: updatedFormData.unit }
                                          : r
                                      ),
                                    })
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                />
                              </td>
                              <td>
                                <TextInputForm
                                  placeholder={"price"}
                                  name="price"
                                  value={row.price_unit}
                                  onChange={(e) =>
                                    handleChange(e, "price_unit", index)
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                />
                              </td>
                              <td>
                                <TextInputForm
                                  placeholder={"amt"}
                                  name="total_amt"
                                  value={row.total_amt}
                                  onChange={(e) =>
                                    handleChange(e, "total_amt", index)
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                />
                              </td>
                              <td >

                                {index === formData.product.length - 1 && (
                                  <ClickButton
                                    label={<>Add</>}
                                    onClick={handleAddRow}
                                  />
                                )}

                              </td>
                              <td>
                                <Delete
                                  onClick={() => handleDeleteRow(index)}
                                  label={<MdDeleteForever />}
                                ></Delete>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="my-3">
            <Container>
              <Row>
                <Col lg="5">{/* <PayMents /> */}</Col>
                <Col lg="7">
                  <div className="inside my-3">
                    <Table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td className="fw-bold">Sub Total</td>
                          <td></td>
                          <td className="w-25 text-end">
                            <TextInputForm
                              placeholder={"Total"}
                              name="total"
                              value={formData.total}
                              onChange={handleTotalChange}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">
                            GST (Apply to All Products)
                          </td>
                          <td></td>
                          <td className="w-25 text-end">
                            <DropDownUI
                              optionlist={alltax}
                              placeholder="Select GST"
                              name="globalGST"
                              value={formData.globalGST}
                              onChange={(updatedFormData) =>
                                handleGlobalGST(updatedFormData)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">GST Amount</td>
                          <td></td>
                          <td className="w-25 text-end">
                            {parseFloat(formData.taxover_amt || 0).toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">Total (Incl. GST)</td>
                          <td></td>
                          <td className="w-25 text-end">
                            {parseFloat(formData.final_total || 0).toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">Round Off</td>
                          <td></td>
                          <td className="w-25 text-end">
                            <input
                              type="checkbox"
                              checked={roundoff}
                              onChange={handleRoundoffChange}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">Roundoff Amount</td>
                          <td></td>
                          <td className="w-25 text-end">
                            {parseFloat(formData.roundoffAmount || 0).toFixed(
                              2
                            )}
                          </td>
                        </tr>
                        {/* <tr>
                          <td className="fw-bold">Paid</td>
                          <td></td>
                          <td className="w-25 text-end">
                            <TextInputForm
                              placeholder={"Paid"}
                              name="paid"
                              value={formData.paid}
                              onChange={handlePaidChange}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold">Balance</td>
                          <td></td>
                          <td className="w-25 text-end">
                            <TextInputForm
                              placeholder={"Balance"}
                              name="balance_amount"
                              value={formData.balance_amount}
                              onChange={handlePaidChange}
                            />
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div className="main stick-bottom">
          <div className="w-50 ms-auto">
            <Container>
              <Row>
                <Col lg="12">
                  <div className="text-center">
                    {type === "edit" ? (
                      <>
                        <ToastContainer
                          position="bottom-center"
                          autoClose={3000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="light"
                          style={{ marginTop: "60px" }}
                        />
                        <span className="mx-2">
                          <ClickButton
                            label={<>Update</>}
                            onClick={handleUpdateSubmit}
                          ></ClickButton>
                        </span>

                        <span className="mx-2">
                          <ClickButton
                            label={<>Cancel</>}
                            onClick={() => navigate("/console/sales/wholesale")}
                          ></ClickButton>
                        </span>
                      </>
                    ) : (
                      <>
                        <ToastContainer
                          position="bottom-center"
                          autoClose={3000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="light"
                          style={{ marginTop: "60px" }}
                        />

                        <span className="mx-2">
                          <ClickButton
                            label={<>Submit</>}
                            onClick={handleSubmit}
                          ></ClickButton>
                        </span>

                        <span className="mx-2">
                          <ClickButton
                            label={<>Cancel</>}
                            onClick={() => navigate("/console/sales/wholesale")}
                          ></ClickButton>
                        </span>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default WholeSaleBillEntry;
